export default "__VITE_ASSET__DPMlG6Iq__"